var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('PanelWithNotifyGroupEditor',{attrs:{"edit":false},on:{"done":function($event){return _vm.$emit('done')}}})}
var staticRenderFns = []

export { render, staticRenderFns }